import '@fontsource/noto-sans-tc'
import '@fontsource/lato'
declare module '@material-ui/core/styles/createMuiTheme' {
  interface Theme {
    variables: Variables
  }
  interface ThemeOptions {
    variables: Variables
  }
}

export interface Variables {
  fontSize18: string
  fontSizeXs: string
  fontSizeSm: string
  fontSizeMd: string
  fontSizeLg: string
  fontSizeXl: string
  fontSizeXXl: string
  fontSizeXXXl: string
  fontFamilyZh: string
  fontFamilyEn: string
  fontWeightBold: 'bold'
  fontWeight400: number
  fontWeight500: number
  fontWeight600: number
  fontColor: string
  fontColorGray: string
  fontColorBlack: string
  buttonColor: string
  selectedColor: string
  deepBlue: string
  allBlue: string
  bottomLineColor: string
  defaultFontFamily: string
}

export const variables: Variables = {
  fontSizeXs: '12px',
  fontSizeSm: '14px',
  fontSizeMd: '16px',
  fontSize18: '18px',
  fontSizeLg: '20px',
  fontSizeXl: '24px',
  fontSizeXXl: '35px',
  fontSizeXXXl: '47px',
  fontFamilyZh: 'Noto Sans TC',
  fontFamilyEn: 'Lato',
  fontWeightBold: 'bold',
  fontWeight400: 400,
  fontWeight500: 500,
  fontWeight600: 600,
  fontColor: '#0f3573',
  fontColorGray: '#55585B',
  buttonColor: '#2053B8',
  selectedColor: '',
  fontColorBlack: '#202833',
  deepBlue: '#153C7B',
  allBlue: '#074570',
  bottomLineColor: '#E3ECFF',
  defaultFontFamily: 'Noto Sans TC',
}
